import React from 'react';
import styled from 'styled-components';
import scaleSize from '../utils/scale-size';

const ItemProgressWrapper = styled.div`
  width: ${({ itemType }) => (itemType === 'catchup-medium' ? scaleSize(455) : scaleSize(275))}px;
  height: ${scaleSize(8)}px;
  background: ${({ background, theme }) => background || theme.imagePlaceholder};
  border-radius: ${scaleSize(8)}px;
  position: absolute;
  bottom: ${scaleSize(65)}px;
  left: ${scaleSize(40)}px;
`;

const ItemProgress = styled.div`
  width: ${({ progress }) => 100 * progress}%;
  height: ${scaleSize(8)}px;
  background: ${({ theme }) => theme.activeColor};
  border-radius: ${scaleSize(8)}px;
`;

export default function Progress({ progress, background, className = '', itemType }) {
  return (
    <ItemProgressWrapper className={className} background={background} itemType={itemType}>
      <ItemProgress progress={progress} />
    </ItemProgressWrapper>
  );
}
